export default {
	'en': {
		'disclaimer': 'Any opinions, findings, conclusions or recommendations expressed in this material / event do not necessarily reflect the views of the Government of the Hong Kong Special Administrative Region and the Environment and Conservation Fund.'
	},
	'tc': {
		'disclaimer': '在此刊物上／任何的項目活動內表達的任何意見、研究成果、結論或建議，並不一定反映香港特別行政區政府及環境及自然保育基金的觀點。'
	}
}